import * as Config from '../../../config';
import ReactDOM from 'react-dom';
import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

import ChevronRight from '../svg/ChevronRight'

function NextGridPortal({ rootID = null, onClick, style }) {
  const [root, setRoot] = useState(null)
  useEffect(() => {
    setTimeout(() => {
      setRoot(document.getElementsByClassName(rootID)[0]);
    }, 500)
  }, [rootID])

  if (root && rootID) {
    let el = document.createElement('div');
    root.appendChild(el);

    return ReactDOM.createPortal((
      <div onClick={onClick} className={`pag-chevron-v2 right flexColumn f-center`} >
        <ChevronRight color={ Config.TYPE_PLACEHOLDER } style={style} />
      </div>
    ), el);
  } else {
    return null
  }
}

NextGridPortal.propTypes = {
  onClick: PropTypes.func,
  rootID: PropTypes.any,
  style: PropTypes.object
}

export default NextGridPortal;
